import React from 'react'
import styles from './Section.scss'

/**
 * 責務: セクションの表示
 * @param { string } title セクションのタイトル
 * @param { any } icon アイコン
 * @param { any } note ノートに表示するテキスト
 * @param { boolean } small サイズ変更フラグ
 * @param { boolean } error エラーフラグ
 * @param { string } className 装飾用のクラス
 * @param { ReactNode } children セクション内部に表示するコンポーネント
 * @returns { JSX.Element } セクションコンポーネントを返す
 */

export const Section = ({
  title,
  icon,
  note,
  small = false,
  error = false,
  className = '',
  children
}) => (
  <section className={`${error ? styles.boxError : styles.box} ${className}`}>
    {title && (
      <div className={small ? styles.boxHeadSmall : styles.boxHead}>
        {title}
        {note && <span className={styles.boxHeadNote}>{note}</span>}
        {icon && <span className={styles.boxHeadIcon}>{icon}</span>}
      </div>
    )}
    <div className={small ? styles.boxMainSmall : styles.boxMain}>{children}</div>
  </section>
)
